import React from 'react';
import { useParsedNewState } from '../useParsedNewState';

export default function SOPNewState({ newStateStr }) {
  const { error, filteredTrades, raw } = useParsedNewState(newStateStr);

  if (error) {
    return <pre className='sop-version-pre mb-0'>{raw}</pre>;
  }
  if (filteredTrades.length === 0) {
    return (
      <div className="new-state-container">
        <p className="sop-new-state-empty">No assigned scopes in this version.</p>
      </div>
    );
  }
  return (
    <div className="new-state-container">
      {filteredTrades.map(trade => (
        <div key={trade.trade_id} className="new-state-trade">
          <div className="new-state-trade-name">{trade.trade_name}</div>
          {trade.assigned_included_scopes && trade.assigned_included_scopes.length > 0 && (
            <div className="new-state-scope-group">
              <strong>Included Scopes:</strong>
              <ul>
                {trade.assigned_included_scopes.map(scope => <li key={scope.id}>{scope.name}</li>)}
              </ul>
            </div>
          )}
          {trade.assigned_additional_scopes && trade.assigned_additional_scopes.length > 0 && (
            <div className="new-state-scope-group">
              <strong>Additional Scopes:</strong>
              <ul>
                {trade.assigned_additional_scopes.map(scope => <li key={scope.id}>{scope.name}</li>)}
              </ul>
            </div>
          )}
          {trade.trade_note && (
            <div className="new-state-notes">
              <strong>Trade Note:</strong>
              <p>{trade.trade_note}</p>
            </div>
          )}
          {trade.company_specific_trade_note && (
            <div className="new-state-notes">
              <strong>Company-Specific Note:</strong>
              <p>{trade.company_specific_trade_note}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
} 